<template>
  <q-item
    v-bind="attrs"
    class="flex items-center justify-between p-8 border border-neutral-100/10 shadow-sm rounded"
  >
    <div class="flex items-center gap-8">
      <div
        class="size-40 rounded-md bg-neutral-20 grid place-items-center"
      >
        <q-icon
          name="svguse:#file_icon"
          class="size-24 text-neutral-70"
        />
      </div>

      <div class="space-y-2">
        <h3
          class="text-headline-4 text-neutral-100 truncate max-w-[35rem]"
        >
          {{ name }}
        </h3>
        <p class="text-paragraph-4 text-neutral-70">
          {{ size || '' }} {{ size && '•' }} {{ date || '' }}
        </p>
      </div>
    </div>

    <div class="flex items-center gap-6">
      <OButton
        v-if="showDownloadBtn"
        class="!w-40"
        @click="handleDownloadFile"
      >
        <q-icon name="download" size="20" />
      </OButton>

      <OButton
        v-if="showDownloadBtn"
        :href="fileUrl"
        class="!w-40"
        target="_blank"
        rel="noopener noreferrer"
      >
        <q-icon name="open_in_new" size="20" />
      </OButton>
    </div>
  </q-item>
</template>

<script setup>
import { computed, ref, useAttrs } from 'vue'
import OButton from 'components/Button/OButton.vue'

const attrs = useAttrs()

const props = defineProps({
  file: { type: Object, required: true },
  name: { type: String, required: true },
  showDownloadBtn: { type: Boolean, default: true },
})

const fileUrl = computed(() => props.file?.arquivo || '')
const date = computed(() => props.file.data_criacao_translated)
const size = computed(
  () => props.file?.tamanho_read || props.file?.size
)

async function handleDownloadFile() {
  const response = await fetch(props.file.arquivo)
  const blob = await response.blob()
  const blobURL = URL.createObjectURL(blob)

  const link = document.createElement('a')
  link.href = blobURL
  link.download = props.file.arquivo.split('/').pop()
  document.body.appendChild(link)
  link.click()
  document.body.removeChild(link)

  URL.revokeObjectURL(blobURL)
}
</script>
